import { call, put, takeEvery } from 'redux-saga/effects';
import { getGroupsList } from '../../requests/get_groups_list_request';
import { getGroupsListSuccess, getGroupsListFailure } from '../actions/get_groups_list.actions';
import { GET_GROUPS_LIST_REQUEST } from '../constants/get_groups_list.constants';
import { message_error } from '../../../../../components/Message';

function* getGroupsListSaga({ _id }) {
    const { result, error, options } = yield call(getGroupsList, _id);
    if (result) {
        yield put(getGroupsListSuccess(options));
    } else {
        yield put(getGroupsListFailure(error));
        message_error(error);
    }
}

export default function* userInfoSaga() {
    yield takeEvery(GET_GROUPS_LIST_REQUEST, getGroupsListSaga);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/redux/sagas/get_groups_list.saga.js